import { ConnectedSelectPage } from "fleet/controller/device/connected-select-page-v2";
import React, { Component } from "react";
import { needsSoftwareUpgradeV2 as needsSoftwareUpgrade } from "redux-store/devices/selectors";
import { needsSoftwareDowngradeV2 as needsSoftwareDowngrade } from "redux-store/devices/selectors";
import { canCancelUpgrade } from "redux-store/devices/selectors";
import { playerVersionsService } from "service/player-versions";

class DeviceUpgradeSoftwarePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allVersions: [],
      loading: true,
    };

    this.fetchVersions = this.fetchVersions.bind(this);
    this.availableVersions = this.availableVersions.bind(this);
  }

  componentDidMount() {
    this.fetchVersions();
  }

  async fetchVersions() {
    this.setState({ loading: true });
    try {
      const resp = await playerVersionsService.load();
      this.setState({
        allVersions: resp.data.upgradable_versions || [],
      });
    } catch (error) {
      console.error("Error loading versions:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  availableVersions() {
    return this.state.allVersions;
  }

  render() {
    const { loading } = this.state;

    if (loading) {
      return <p>Loading versions...</p>;
    }

    const successMessage =
      "Device software upgrade request processed " +
      "successfully. Your devices will be upgraded shortly.";

    return (
      <ConnectedSelectPage
        title="Change Player Versions"
        upgradeDeviceFilter={needsSoftwareUpgrade}
        downgradeDeviceFilter={needsSoftwareDowngrade}
        cancelUpgradeFilter={canCancelUpgrade}
        successMessage={successMessage}
        versionSelectorEnabled={true}
        availableVersions={this.availableVersions}
        startPage={1}
      />
    );
  }
}

export { DeviceUpgradeSoftwarePage };
